import React from 'react';
import PropTypes from 'prop-types';
import { GapCard, FocSubmit, LitePlanNotification } from '~/components/Patient';
import { getGapsByCategory, gapShouldShowControl } from '~/util';

const propTypes = {
    patient: PropTypes.shape({
        id: PropTypes.number.isRequired,
        foc_gaps: PropTypes.arrayOf(
            PropTypes.shape({
                measure: PropTypes.shape({
                    measure_category: PropTypes.shape({
                        id: PropTypes.number,
                        description: PropTypes.string,
                    }),
                }),
                id: PropTypes.number.isRequired,
            })
        ),
        metadata: PropTypes.shape({
            AttestationVisibility: PropTypes.bool,
            FOCVisibility: PropTypes.bool,
            SDSVisibility: PropTypes.bool,
        }),
    }).isRequired,
    status: PropTypes.number.isRequired,
};

export function FOC({ patient, status }) {
    const gapsByCategory = getGapsByCategory(patient.foc_gaps, status)
        .map((x) => {
            if (x.name === 'FOC Measures') x.name = 'Primary';
            if (x.name === 'FOC Measures/Secondary') x.name = 'Secondary';
            return x;
        })
        .filter((x) => x.gaps.length > 0);

    return (
        <div>
            {gapShouldShowControl(status) && (
                <div className="row mb-3">
                    <div className="col text-end">
                        <FocSubmit patient={patient} />
                    </div>
                </div>
            )}
            <div className="patient-gaps-container">
                <LitePlanNotification show={patient?.metadata?.FOCVisibility === false} />
                {gapsByCategory.map((cat) => (
                    <div className="foc-gap-category-container" key={cat.name}>
                        <div>
                            <div className="h5 fw-bold">{cat.name}</div>
                        </div>
                        <div className="row">
                            {cat.gaps.map((gap) => (
                                <GapCard
                                    gap={gap}
                                    key={gap.id}
                                    patientId={patient.id}
                                    statusFilter={status}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

FOC.propTypes = propTypes;
